import { render, staticRenderFns } from "./CourseReview.vue?vue&type=template&id=6a264a00&scoped=true&"
import script from "./CourseReview.vue?vue&type=script&lang=js&"
export * from "./CourseReview.vue?vue&type=script&lang=js&"
import style0 from "./CourseReview.vue?vue&type=style&index=0&id=6a264a00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a264a00",
  null
  
)

export default component.exports